// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Hosting Fiyatları',
  subtitle: 'Hosting paketi fiyatlarını yönetin',
  addNew: 'Yeni Paket',
  edit: 'Düzenle',
  packageName: 'Paket Adı',
  packageType: 'Paket Türü',
  purchasePrice: 'Alış Fiyatı',
  salePrice: 'Satış Fiyatı',
  currency: 'Para Birimi',
  status: 'Durum',
  actions: 'İşlemler',
  noPrices: 'Henüz paket tanımlanmadı',
  noPricesDesc: 'İlk paketinizi ekleyerek başlayın.',
  noPricesHint: 'Henüz fiyat tanımlanmadı. İlk paketinizi ekleyerek başlayın.',
  priceAdded: 'Paket başarıyla eklendi',
  priceUpdated: 'Paket başarıyla güncellendi',
  priceDeleted: 'Paket başarıyla silindi',
  fetchError: 'Paketler alınamadı',
  addError: 'Paket eklenemedi',
  updateError: 'Paket güncellenemedi',
  deleteError: 'Paket silinemedi',
  confirmDelete: 'Bu paketi silmek istediğinizden emin misiniz?',
  typeShared: 'Shared Hosting',
  typeVps: 'VPS',
  typeDedicated: 'Dedicated',
  typeReseller: 'Reseller',
  typeCloud: 'Cloud',
  typeOther: 'Diğer',
  profit: 'Kar',
  listTitle: 'Hosting Paket Listesi',
  addTitle: 'Yeni Hosting Paketi Ekle',
  editTitle: 'Hosting Paketi Düzenle',
  selectHosting: 'Sunucu Seçin',
  manualEntry: 'Manuel Giriş',
  noServers: 'Sunucu bulunmuyor',
  noServersHint: 'Önce Sunucular sayfasından sunucu ekleyin',
  packageNamePlaceholder: 'Örn: Basic Hosting, Premium Hosting',
  autoFillHint: 'Sunucu seçildiğinde paket adı otomatik doldurulur',
  addPrice: 'Paket Ekle',
  infoText: 'Hosting paketleri için fiyat tanımlayın. Sunucu eklerken paket adı otomatik doldurulur.',
  serversLoadError: 'Sunucular yüklenemedi',
  addSuccess: 'Paket başarıyla eklendi',
  updateSuccess: 'Paket başarıyla güncellendi',
  deleteSuccess: 'Paket başarıyla silindi',
  statusUpdateSuccess: 'Durum başarıyla güncellendi',
  statusUpdateError: 'Durum güncellenemedi',
  gold: 'Altın'
};
